import React from 'react';
import BrowseExtParent from './BrowseExtParent';
import './BrowseExtDirectory.css';
import { BROWSE_EXT_CONSTANT } from '../../util/Constants';

type browseExtDirectoryProps = {
  bucketName: string
};
function BrowseExtDirectory(props: browseExtDirectoryProps) {
  return (
    <div name="BrowseExtDirectory" className="flex-row">
      <div>
        <BrowseExtParent parent_key={BROWSE_EXT_CONSTANT.KEYS.ROOT} bucketName={props.bucketName} type={BROWSE_EXT_CONSTANT.NODE_TYPE.FOLDER}></BrowseExtParent>
      </div>
    </div>
  );
}

export default BrowseExtDirectory;
